import apiClient from '../api/axiosConfig';
import { API_ENDPOINTS } from '../constants';

export const jobApi = {
  getJobs(page, perPage, search) {
    return apiClient.get(API_ENDPOINTS.JOBS, {
      params: {
        page,
        per_page: perPage,
        search,
      },
    });
  },

  processJobs() {
    return apiClient.post(`${API_ENDPOINTS.JOBS}/process`);
  },
};